// src/index.ts
import { useEffect, useRef } from "react";
function useOnClickOutside(onClick, dependencies = []) {
  const ref = useRef(null);
  useEffect(() => {
    const handleEvent = (event) => {
      var _a;
      if (!((_a = ref.current) == null ? void 0 : _a.contains(event.target))) {
        onClick(event);
      }
    };
    window.addEventListener("click", handleEvent);
    return () => window.removeEventListener("click", handleEvent);
  }, [ref, ...dependencies]);
  return ref;
}
export {
  useOnClickOutside as default
};
